export default function isHttpMaintenance(res: any) {
  if (res.response && res.response.status === 503) {
    return true
  }
  return false
}
